import React from "react";
import {connect} from "react-redux";
import PostFeed from "../Feed/PostFeed/PostFeed";
//import {getPost} from "../../API/api-static";
import {getPost,getBookmark} from "../../API/API";
import {ActivityIndicator, Image, TouchableOpacity, View} from "react-native";
import {compose} from "redux";
import {withTranslation} from "react-i18next";

class PostScreen extends React.Component{

    constructor(props) {
        super(props);
        this.postId = this.props.route.params.postId;

        this.state= {
            post : undefined,
            isLoading : true,
        }
    }

    componentDidMount() {
        this.getBookmark();
        this.setState({ isLoading: true });
        getPost(this.postId).then(data => {
            if(data=="Not Acceptable"){
                this._deconnexion();
            }
            this.setState({
                post: data,
                isLoading: false
            },
                ()=>{}
            );
            this._setTitle(data.type);
         });
    }

    _setTitle(title){
        const styleHeaderGlobalWhite = {
            backgroundColor : this.props.theme.colors.primary.White.value,
            height:80
        }  ;

        this.props.navigation.setOptions(
            {
                headerTitleAlign: "center",
                headerStyle: styleHeaderGlobalWhite,
                headerTitleStyle:{textTransform: 'capitalize', fontFamily: this.props.theme.fonts.title},
                title : this.props.t(this._formateTitle(title)),
                headerLeft : ()=><TouchableOpacity onPress={this.props.navigation.goBack}>
                    <Image resizeMode={"contain"} style={{width:20,height: 20,marginLeft:20, flex: 1}} source={this.props.theme.pictos.chevronGaucheMediumPicto.light} />
                </TouchableOpacity>
            }
        );
    }

    _formateTitle(title){
        switch (title){
            case 'news' :
                return "News";
            case 'synthesis':
                return  "Synthese";
            case 'memo':
                return "Memo";
            default:
                return "News";
        }
    }

    _displayLoading(){

        if(this.state.isLoading){
            return(
                <View style={{  position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, alignItems: 'center', justifyContent: 'center'}}>
                    <ActivityIndicator size='large' color="#000" />
                </View>
            );
        }
    }

    _displayPost(){
        if(this.state.post!==undefined){
            return (
                <PostFeed bookmark={this.state.bookmark} refNavigation={this.props.navigation} route={this.props.route}
                          isPost={true}  post={ {item : this.state.post}} />
            );
        }
    }

    _deconnexion(){
        const action = {'type': 'SIGN_OUT', 'value': ""};
        this.props.dispatch(action);
    }


    getBookmark(){
        getBookmark().then(data=>{
            this.state.bookmark = data
        });
    }

    render() {
        return (
                <View>
                    {this._displayLoading()}
                    { this._displayPost() }
                </View>
        );
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default compose(withTranslation(),connect(mapStateToProps))(PostScreen);
